import React from 'react';
import { string, bool, object, func } from 'prop-types';
import T from 'i18n-react';
import { actions as pushpinActions } from '../../../../../../../constants/pushpin-visibility';
import { issueAttributesType } from '../../../../../../../constants/proptype-validation';
import { canChangePushpinVisibility, isPushpinVisible } from '../../../../../../../utils/issues-helpers';
import { ActionButton } from '@adsk/bim360-matrix-react-components';
import trashIcon from '../../../../../../../assets/images/icons/icon-trash.svg';

const DocumentActionsMenu = ({ container, issue, isChangingPushpinVisibility, isDeletingPushpin, hiddenIcon, visibleIcon, handleDocumentAction, canDeletePushpin }) => {

  const commonOptionAttributes = {
    width: '20px',
    height: '20px',
  };
  const hideOption = {
    key: pushpinActions.HIDE,
    label: T.translate('preview.header.actionsMenu.hide'),
    svg: hiddenIcon,
    disabled: isChangingPushpinVisibility,
    ...commonOptionAttributes,
  };
  const showOption = {
    key: pushpinActions.SHOW,
    label: T.translate('preview.header.actionsMenu.show'),
    svg: visibleIcon,
    disabled: isChangingPushpinVisibility,
    ...commonOptionAttributes,
  };
  const deletePushpin = {
    key: pushpinActions.DELETE,
    label: T.translate('preview.header.actionsMenu.delete'),
    svg: trashIcon,
    disabled: isDeletingPushpin,
    ...commonOptionAttributes,
  };

  const options = [];

  if (canDeletePushpin) {
    options.push(deletePushpin);
  }

  if (canChangePushpinVisibility(issue)) {
    if (isPushpinVisible(issue)) {
      options.push(hideOption);
    } else {
      options.push(showOption);
    }
  }

  if (!options.length) {
    return null;
  }

  return (
    <ActionButton
      container={container}
      className="LinkedDocumentInlineEdit__visibility-action-menu-button"
      tooltipClassName="LinkedDocumentInlineEdit__action-popover"
      options={options}
      onSelect={handleDocumentAction}
    />
  );
};

DocumentActionsMenu.propTypes = {
  issue: issueAttributesType.isRequired,
  container: object.isRequired,
  hiddenIcon: string.isRequired,
  visibleIcon: string.isRequired,
  isChangingPushpinVisibility: bool.isRequired,
  isDeletingPushpin: bool.isRequired,
  handleDocumentAction: func.isRequired,
  canDeletePushpin: bool,
};

export default DocumentActionsMenu;
